import React, { Component } from 'react';
import { Tabs } from 'antd';
import Filter from './Filter';
import List from './List';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import dictCache from '../../../../../common/dictCache';

const { TabPane } = Tabs;

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            load: null,
            areaOptions: [],
        };
    }

    componentDidMount() {
        this.loadAreaList();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea, {}).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }
    
    search = () => {
        this.setState({ load: {} });
    }

    getContent = () => {
        const { searchParams, clientHeight, notice } = this.props;
        const { load } = this.state;
        const height = clientHeight - 72 - 94 - 45 - 100;
        return (
            <List
                load={load}
                height={height}
                notice={notice}
                searchParams={searchParams}
            />
        );
    }

    render() {
        const { searchParams, businessList, onChange } = this.props;
        const { activeKey, areaOptions } = this.state;

        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    activeKey={activeKey}
                    searchParams={searchParams}
                    businessList={businessList}
                    onChange={onChange}
                    areaOptions={areaOptions}
                />
                {this.getContent()}
            </div>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/ArrivedMilestone/TablePage/index.js